import React from "react";
import { useSelector } from "react-redux";
import Content from "../../commons/components/content"
import PersonalContainer from "./PersonalContainer/personalContainer";
import DataHeader from "./DataHeader/dataHeader";
import OfficeContainer from "./OfficeContainer/officeContainer";

export default () => {
    const { userData } = useSelector(state => state.userLogin);

    return (
        <Content>
            <DataHeader userData={userData} />
            <PersonalContainer userData={userData} />
            {userData.id && <OfficeContainer userData={userData} />}
        </Content>
    )
}
